// src/components/landing/CtaBanner.jsx
import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import { motion } from 'framer-motion';

export default function CtaBanner({ onEnroll }) {
  return (
    <Box sx={{
      background: 'linear-gradient(135deg,#1d4ed8 0%,#1d6cf0 45%,#0ea5e9 100%)',
      py: { xs: 8, md: 10 }, px: { xs: 3, md: 8 },
      display: 'flex', flexDirection: { xs: 'column', md: 'row' },
      alignItems: { xs: 'flex-start', md: 'center' }, justifyContent: 'space-between',
      gap: 4, position: 'relative', overflow: 'hidden',
    }}>
      <motion.div
        initial={{ opacity: 0, x: -30 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        style={{ position: 'relative', zIndex: 1 }}
      >
        <Typography sx={{ fontSize: { xs: '1.7rem', md: '2.1rem' }, fontWeight: 900, color: '#fff', mb: 1 }}>
          Ready to Start Your IT Career?
        </Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.65)', fontSize: '0.95rem', maxWidth: 480, lineHeight: 1.75 }}>
          Join thousands of Kerala students who have launched government and private careers through BSS IT Mission's recognized programs.
        </Typography>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, x: 30 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.15 }}
        style={{ flexShrink: 0, position: 'relative', zIndex: 1 }}
      >
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
          <Button onClick={onEnroll} size="large" sx={{
            background: '#fff', color: '#1d4ed8', borderRadius: 0, px: 4, py: 1.75,
            fontWeight: 700, fontSize: '0.95rem', textTransform: 'none',
            boxShadow: 'none',
            '&:hover': { background: '#f0f9ff', boxShadow: 'none' },
          }}>
            Enroll Now →
          </Button>
          <Button href="#contact" size="large" sx={{
            color: '#fff', border: '2px solid rgba(255,255,255,0.6)', borderRadius: 0,
            px: 4, py: 1.75, fontWeight: 600, fontSize: '0.95rem', textTransform: 'none',
            background: 'transparent',
            '&:hover': { border: '2px solid #fff', background: 'rgba(255,255,255,0.1)' },
          }}>
            Find Nearest Center
          </Button>
        </Stack>
      </motion.div>
    </Box>
  );
}
